"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgSetOracleSlashEnabledResponse = exports.MsgSetOracleSlashEnabled = exports.MsgRemoveOracleResponse = exports.MsgRemoveOracle = exports.MsgUpdateOracleResponse = exports.UpdateOracleParams = exports.MsgUpdateOracle = exports.MsgCreateVoteResponse = exports.MsgCreateVote = exports.MsgCreateOracleResponse = exports.CreateOracleParams = exports.MsgCreateOracle = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("./params");
const wrappers_1 = require("../../../google/protobuf/wrappers");
exports.protobufPackage = "Switcheo.carbon.oracle";
const baseMsgCreateOracle = { creator: "" };
exports.MsgCreateOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.createOracleParams !== undefined) {
            exports.CreateOracleParams.encode(message.createOracleParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.createOracleParams = exports.CreateOracleParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateOracle);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.createOracleParams =
            object.createOracleParams !== undefined &&
                object.createOracleParams !== null
                ? exports.CreateOracleParams.fromJSON(object.createOracleParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.createOracleParams !== undefined &&
            (obj.createOracleParams = message.createOracleParams
                ? exports.CreateOracleParams.toJSON(message.createOracleParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateOracle);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.createOracleParams =
            object.createOracleParams !== undefined &&
                object.createOracleParams !== null
                ? exports.CreateOracleParams.fromPartial(object.createOracleParams)
                : undefined;
        return message;
    },
};
const baseCreateOracleParams = {
    creator: "",
    id: "",
    description: "",
    minTurnoutPercentage: long_1.default.ZERO,
    maxResultAge: long_1.default.ZERO,
    securityType: "",
    resultStrategy: "",
    resolution: long_1.default.ZERO,
    spec: "",
};
exports.CreateOracleParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        if (!message.minTurnoutPercentage.isZero()) {
            writer.uint32(32).int64(message.minTurnoutPercentage);
        }
        if (!message.maxResultAge.isZero()) {
            writer.uint32(40).int64(message.maxResultAge);
        }
        if (message.securityType !== "") {
            writer.uint32(50).string(message.securityType);
        }
        if (message.resultStrategy !== "") {
            writer.uint32(58).string(message.resultStrategy);
        }
        if (!message.resolution.isZero()) {
            writer.uint32(64).int64(message.resolution);
        }
        if (message.spec !== "") {
            writer.uint32(74).string(message.spec);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCreateOracleParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                case 3:
                    message.description = reader.string();
                    break;
                case 4:
                    message.minTurnoutPercentage = reader.int64();
                    break;
                case 5:
                    message.maxResultAge = reader.int64();
                    break;
                case 6:
                    message.securityType = reader.string();
                    break;
                case 7:
                    message.resultStrategy = reader.string();
                    break;
                case 8:
                    message.resolution = reader.int64();
                    break;
                case 9:
                    message.spec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCreateOracleParams);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : "";
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromString(object.minTurnoutPercentage)
                : long_1.default.ZERO;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromString(object.maxResultAge)
                : long_1.default.ZERO;
        message.securityType =
            object.securityType !== undefined && object.securityType !== null
                ? String(object.securityType)
                : "";
        message.resultStrategy =
            object.resultStrategy !== undefined && object.resultStrategy !== null
                ? String(object.resultStrategy)
                : "";
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromString(object.resolution)
                : long_1.default.ZERO;
        message.spec =
            object.spec !== undefined && object.spec !== null
                ? String(object.spec)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined && (obj.id = message.id);
        message.description !== undefined &&
            (obj.description = message.description);
        message.minTurnoutPercentage !== undefined &&
            (obj.minTurnoutPercentage = (message.minTurnoutPercentage || long_1.default.ZERO).toString());
        message.maxResultAge !== undefined &&
            (obj.maxResultAge = (message.maxResultAge || long_1.default.ZERO).toString());
        message.securityType !== undefined &&
            (obj.securityType = message.securityType);
        message.resultStrategy !== undefined &&
            (obj.resultStrategy = message.resultStrategy);
        message.resolution !== undefined &&
            (obj.resolution = (message.resolution || long_1.default.ZERO).toString());
        message.spec !== undefined && (obj.spec = message.spec);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, baseCreateOracleParams);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "";
        message.description = (_c = object.description) !== null && _c !== void 0 ? _c : "";
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromValue(object.minTurnoutPercentage)
                : long_1.default.ZERO;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromValue(object.maxResultAge)
                : long_1.default.ZERO;
        message.securityType = (_d = object.securityType) !== null && _d !== void 0 ? _d : "";
        message.resultStrategy = (_e = object.resultStrategy) !== null && _e !== void 0 ? _e : "";
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromValue(object.resolution)
                : long_1.default.ZERO;
        message.spec = (_f = object.spec) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
const baseMsgCreateOracleResponse = { id: "" };
exports.MsgCreateOracleResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateOracleResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateOracleResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMsgCreateVote = {
    creator: "",
    oracleId: "",
    timestamp: long_1.default.ZERO,
    data: "",
};
exports.MsgCreateVote = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.oracleId !== "") {
            writer.uint32(18).string(message.oracleId);
        }
        if (!message.timestamp.isZero()) {
            writer.uint32(24).int64(message.timestamp);
        }
        if (message.data !== "") {
            writer.uint32(34).string(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateVote);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.oracleId = reader.string();
                    break;
                case 3:
                    message.timestamp = reader.int64();
                    break;
                case 4:
                    message.data = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateVote);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromString(object.timestamp)
                : long_1.default.ZERO;
        message.data =
            object.data !== undefined && object.data !== null
                ? String(object.data)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        message.timestamp !== undefined &&
            (obj.timestamp = (message.timestamp || long_1.default.ZERO).toString());
        message.data !== undefined && (obj.data = message.data);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgCreateVote);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.oracleId = (_b = object.oracleId) !== null && _b !== void 0 ? _b : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromValue(object.timestamp)
                : long_1.default.ZERO;
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgCreateVoteResponse = {};
exports.MsgCreateVoteResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateVoteResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateVoteResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateVoteResponse);
        return message;
    },
};
const baseMsgUpdateOracle = { updater: "" };
exports.MsgUpdateOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updater !== "") {
            writer.uint32(10).string(message.updater);
        }
        if (message.updateOracleParams !== undefined) {
            exports.UpdateOracleParams.encode(message.updateOracleParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.updater = reader.string();
                    break;
                case 2:
                    message.updateOracleParams = exports.UpdateOracleParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateOracle);
        message.updater =
            object.updater !== undefined && object.updater !== null
                ? String(object.updater)
                : "";
        message.updateOracleParams =
            object.updateOracleParams !== undefined &&
                object.updateOracleParams !== null
                ? exports.UpdateOracleParams.fromJSON(object.updateOracleParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.updater !== undefined && (obj.updater = message.updater);
        message.updateOracleParams !== undefined &&
            (obj.updateOracleParams = message.updateOracleParams
                ? exports.UpdateOracleParams.toJSON(message.updateOracleParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateOracle);
        message.updater = (_a = object.updater) !== null && _a !== void 0 ? _a : "";
        message.updateOracleParams =
            object.updateOracleParams !== undefined &&
                object.updateOracleParams !== null
                ? exports.UpdateOracleParams.fromPartial(object.updateOracleParams)
                : undefined;
        return message;
    },
};
const baseUpdateOracleParams = { id: "" };
exports.UpdateOracleParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.description !== undefined) {
            wrappers_1.StringValue.encode({ value: message.description }, writer.uint32(18).fork()).ldelim();
        }
        if (message.status !== undefined) {
            wrappers_1.StringValue.encode({ value: message.status }, writer.uint32(26).fork()).ldelim();
        }
        if (message.minTurnoutPercentage !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.minTurnoutPercentage }, writer.uint32(34).fork()).ldelim();
        }
        if (message.maxResultAge !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.maxResultAge }, writer.uint32(42).fork()).ldelim();
        }
        if (message.securityType !== undefined) {
            wrappers_1.StringValue.encode({ value: message.securityType }, writer.uint32(50).fork()).ldelim();
        }
        if (message.resultStrategy !== undefined) {
            wrappers_1.StringValue.encode({ value: message.resultStrategy }, writer.uint32(58).fork()).ldelim();
        }
        if (message.resolution !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.resolution }, writer.uint32(66).fork()).ldelim();
        }
        if (message.spec !== undefined) {
            wrappers_1.StringValue.encode({ value: message.spec }, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateOracleParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.description = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.status = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.minTurnoutPercentage = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.maxResultAge = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.securityType = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.resultStrategy = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.resolution = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.spec = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateOracleParams);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : undefined;
        message.status =
            object.status !== undefined && object.status !== null
                ? String(object.status)
                : undefined;
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromValue(object.minTurnoutPercentage)
                : undefined;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromValue(object.maxResultAge)
                : undefined;
        message.securityType =
            object.securityType !== undefined && object.securityType !== null
                ? String(object.securityType)
                : undefined;
        message.resultStrategy =
            object.resultStrategy !== undefined && object.resultStrategy !== null
                ? String(object.resultStrategy)
                : undefined;
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromValue(object.resolution)
                : undefined;
        message.spec =
            object.spec !== undefined && object.spec !== null
                ? String(object.spec)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.description !== undefined &&
            (obj.description = message.description);
        message.status !== undefined && (obj.status = message.status);
        message.minTurnoutPercentage !== undefined &&
            (obj.minTurnoutPercentage = message.minTurnoutPercentage);
        message.maxResultAge !== undefined &&
            (obj.maxResultAge = message.maxResultAge);
        message.securityType !== undefined &&
            (obj.securityType = message.securityType);
        message.resultStrategy !== undefined &&
            (obj.resultStrategy = message.resultStrategy);
        message.resolution !== undefined && (obj.resolution = message.resolution);
        message.spec !== undefined && (obj.spec = message.spec);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, baseUpdateOracleParams);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : undefined;
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : undefined;
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromValue(object.minTurnoutPercentage)
                : undefined;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromValue(object.maxResultAge)
                : undefined;
        message.securityType = (_d = object.securityType) !== null && _d !== void 0 ? _d : undefined;
        message.resultStrategy = (_e = object.resultStrategy) !== null && _e !== void 0 ? _e : undefined;
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromValue(object.resolution)
                : undefined;
        message.spec = (_f = object.spec) !== null && _f !== void 0 ? _f : undefined;
        return message;
    },
};
const baseMsgUpdateOracleResponse = {};
exports.MsgUpdateOracleResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateOracleResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateOracleResponse);
        return message;
    },
};
const baseMsgRemoveOracle = { creator: "", oracleId: "" };
exports.MsgRemoveOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.oracleId !== "") {
            writer.uint32(18).string(message.oracleId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.oracleId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveOracle);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveOracle);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.oracleId = (_b = object.oracleId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveOracleResponse = {};
exports.MsgRemoveOracleResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveOracleResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveOracleResponse);
        return message;
    },
};
const baseMsgSetOracleSlashEnabled = { creator: "", enabled: false };
exports.MsgSetOracleSlashEnabled = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.enabled === true) {
            writer.uint32(16).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetOracleSlashEnabled);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetOracleSlashEnabled);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.enabled =
            object.enabled !== undefined && object.enabled !== null
                ? Boolean(object.enabled)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetOracleSlashEnabled);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.enabled = (_b = object.enabled) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
const baseMsgSetOracleSlashEnabledResponse = {};
exports.MsgSetOracleSlashEnabledResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetOracleSlashEnabledResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetOracleSlashEnabledResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetOracleSlashEnabledResponse);
        return message;
    },
};
const baseMsgUpdateParams = { authority: "" };
exports.MsgUpdateParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            params_1.ParamsToUpdate.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = params_1.ParamsToUpdate.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined &&
            (obj.params = message.params
                ? params_1.ParamsToUpdate.toJSON(message.params)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseMsgUpdateParamsResponse = {};
exports.MsgUpdateParamsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateOracle = this.CreateOracle.bind(this);
        this.CreateVote = this.CreateVote.bind(this);
        this.UpdateOracle = this.UpdateOracle.bind(this);
        this.RemoveOracle = this.RemoveOracle.bind(this);
        this.SetOracleSlashEnabled = this.SetOracleSlashEnabled.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateOracle(request) {
        const data = exports.MsgCreateOracle.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "CreateOracle", data);
        return promise.then((data) => exports.MsgCreateOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    CreateVote(request) {
        const data = exports.MsgCreateVote.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "CreateVote", data);
        return promise.then((data) => exports.MsgCreateVoteResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateOracle(request) {
        const data = exports.MsgUpdateOracle.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "UpdateOracle", data);
        return promise.then((data) => exports.MsgUpdateOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveOracle(request) {
        const data = exports.MsgRemoveOracle.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "RemoveOracle", data);
        return promise.then((data) => exports.MsgRemoveOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetOracleSlashEnabled(request) {
        const data = exports.MsgSetOracleSlashEnabled.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "SetOracleSlashEnabled", data);
        return promise.then((data) => exports.MsgSetOracleSlashEnabledResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
